var mixin_intro_tabs = {
  mixins: [getSetSessionStorage],
  data() {
    return {
      tab: null,
      savedSessionTab: null,
    }
  },
  mounted() {
    this.savedSessionTab = this.getSingleSessionItem(this.$el.id)
    if (this.savedSessionTab) {
      this.changeTab(this.savedSessionTab)
    }
  },
  methods: {
    async changeTab(newTab) {
      this.tab = newTab
      await this.$nextTick()
      this.setSession()
    },
    activeClass(tab) {
      if (this.tab === tab) {
        return 'ui-tabs-active'
      }
      return ''
    },
    setSession() {
      this.setSingleSessionItem(this.$el.id, this.tab)
    },
  },
}
